/*
* @author 友人a丶
* meta元属性
* cache，代表页面是否缓存(true,缓存），默认不写为false
* icon，菜单的图标
* menu，是否作为菜单，默认不写为true
* */
import config from "@/config";
import AdminLayout from "@/layouts/admin-layout";

export default [
    {
        path: "/",
        redirect: config.index,
        component: AdminLayout,
    }
];
